import React, { Component } from 'react'
import Table from 'react-bootstrap/Table'

import Chart from "react-apexcharts"

import moment from 'moment'

import './Logs.css'


class Stats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      progress: null,
    }
  }

  componentDidMount() {
    this.updateState()
  }

  componentDidUpdate(prevProps) {
    if (this.equalsLogs(prevProps.logs, this.props.logs)) {
      return
    }
    this.updateState()
  }

  equalsLogs(logs1, logs2) {
    if (!logs1 || !logs2) {
      return false
    }
    if (logs1.length !== logs2.length) {
      return false
    }
    return logs1.every((l1, index) => this.equalLog(l1, logs2[index]))
  }

  equalLog(log1, log2) {
    if (log1.data.finished !== log2.data.finished) {
      return false
    }
    if (log1.data.user !== log2.data.user) {
      return false
    }
    if (log1.data.type !== log2.data.type) {
      return false
    }
    if (JSON.stringify(log1.data.data) !== JSON.stringify(log2.data.data)) {
      return false
    }
    return true
  }

  updateState() {
    if (!this.props.logs) {
      this.setState({
        progress: null,
      })
      return
    }
    const users = {}
    this.props.logs.forEach(log => {
      if (log.data.type !== 'clozereaderv2') {
        return
      }
      if (log.data.data.type !== 'finished' && log.data.data.type !== 'sentence') {
        console.log('ignored', log.data.data)
        return
      }
      let userlogs = users[log.data.user]
      if (!userlogs) {
        userlogs = []
        users[log.data.user] = userlogs
      }
      userlogs.push({
        updated: log.data.finished,
        sentences: this.computeSentences(log.data.data),
        scores: this.computeScores(log.data.data),
      })
    })

    console.log('Stats', users);
    const progress = Object.entries(users).map(u => ({
      user: u[0],
      updated: Math.max(...u[1].map(log => log.updated)),
      sentences: Math.max(...u[1].map(log => log.sentences)),
      score: Math.max(...u[1].map(log => log.scores)),
    }))
    this.setState({
      progress,
      options: {
        chart: {
          id: "basic-bar"
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        xaxis: {
          categories: progress.map(p => p.user)
        }
      },
      series: [
        {
          name: "Sentences",
          data: progress.map(p => p.sentences)
        },
        {
          name: "Score",
          data: progress.map(p => p.score)
        }
      ]
    })
  }

  computeScores(data) {
    const scores = {};
    (data.answers || []).forEach(answer => {
      const oldScore = scores[`${answer.rowIndex}:${answer.beginIndex}`]
      const score = this.computeScoresForAnswer(answer)
      scores[`${answer.rowIndex}:${answer.beginIndex}`] = oldScore ? Math.max(oldScore, score) : score
    })
    return Object.values(scores).reduce((a, b) => a + b, 0)
  }

  computeScoresForAnswer(answer) {
    let score = 0;
    (answer.answers || []).forEach(a => {
      score += a.answer.map(ans => ans.answer === ans.correct ? 1 : 0).reduce((a, b) => a + b, 0)
    })
    return score
  }

  computeSentences(data) {
    const sentences = {};
    (data.answers || []).forEach(answer => {
      sentences[`${answer.rowIndex}:${answer.beginIndex}`] = 1
    })
    return Object.keys(sentences).length
  }

  render() {
    return <div className='TaskEditor'>
      {(!this.props.logs || this.props.logs.length === 0) && <div>
          Cloze Test はまだ実施されていません。
        </div>}
      {this.props.logs && this.props.logs.length > 0 && <div>
        {this.state.series && <div>
            実施文章数(Sentences) + 獲得点数(Score)
            <Chart
              options={this.state.options}
              series={this.state.series}
              type="bar"
              width="500"
            />
          </div>}
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>実施者</th>
              <th>最終実行</th>
              <th>実施文章数</th>
              <th>点数(完全一致)</th>
            </tr>
          </thead>
          <tbody>
            {(this.state.progress || []).map(log => <tr key={log.user}>
                <td>{log.user}</td>
                <td>{moment(new Date(log.updated)).format()}</td>
                <td>{log.sentences}</td>
                <td>{log.score}</td>
              </tr>)}
          </tbody>
        </Table>
      </div>}
    </div>
  }
}

export default Stats;
